// constants for the key names returned from the RADE
export const CHATBOT_RESPONSES = 'Chatbot Responses';
export const FEEDBACKFORM = 'feedbackForm';
export const LIVESTREAMS = 'livestreams';
export const SUGGESTED_SCRIPT_RESPONSES = 'Suggested Script Responses';
